'use client'
import { useEffect, useState } from 'react'
import { useSearchParams, useRouter } from 'next/navigation'
import ProfileData from '@/components/profile/ProfileData'
import OrderList from '@/components/profile/OrderList'
import EventBookings from '@/components/profile/EventBookings'
import Wishlist from '@/components/profile/Wishlist'
import AddressList from '@/components/profile/AddressList'
import ReturnExchange from '@/components/profile/ReturnExchange'
import TermsOfServices from '@/components/profile/TermsOfServices'
import PrivacyPolicy from '@/components/profile/PrivacyPolicy'
import ProfileSidebar from '@/components/profile/ProfileSidebar'
import ProfileMobileMenu from '@/components/profile/ProfileMobileMenu'
import useCommonStore from '@/store/commonStore'
import CommonHeader from '@/components/common/CommonHeader'



function getTabComponent(tab: string | null) {
  switch (tab) {
    case 'profile':
      return <ProfileData />
    case 'orders':
      return <OrderList />
    case 'events':
      return <EventBookings />
    case 'wishlist':
      return <Wishlist />
    case 'address':
      return <AddressList />
    case 'returns':
      return <ReturnExchange />
    case 'terms':
      return <TermsOfServices />
    case 'privacy':
      return <PrivacyPolicy />
    default:
      return null
  }
}

export default function ProfilePage() {
  const searchParams = useSearchParams()
  const router = useRouter()
  const { isAuth,translations } = useCommonStore()

  const NAV_ITEMS = [
  { label: `${translations["edt_prfl"]||'Edit profile'}`, key: 'profile' },
  { label: `${translations["order"]||'Orders'}`, key: 'orders' },
  { label: `${translations["evnt_bkg"]||'Event bookings'}`, key: 'events' },
  { label: `${translations["wishlist"]||'Wishlist'}`, key: 'wishlist' },
  { label: `${translations["add_list"]||'Address list'}`, key: 'address' },
  { label: `${translations["rtn_exchg"]||'Return & Exchanges'}`, key: 'returns' },
  { label: `${translations["trm_cdtn"]||'Terms of services'}`, key: 'terms' },
  { label: `${translations["prvcy_polcy"]||'Privacy policy'}`, key: 'privacy' },
]

  // Initially null = show tabs menu instead of ProfileData
  const [activeTab, setActiveTab] = useState<string | null>(null)

  // Sync tab with URL
  useEffect(() => {
    const tab = searchParams.get('tab')
    if (tab && NAV_ITEMS.some(i => i.key === tab)) {
      setActiveTab(tab)
    } else {
      setActiveTab(null) // null = show tabs menu
    }
  }, [searchParams])

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey)
    router.push(`/profile?tab=${tabKey}`)
  }

  // Redirect if not logged in
  useEffect(() => {
    if (!isAuth) {
      router.push(`/login?redirect=/profile${activeTab ? `?tab=${activeTab}` : ''}`)
    }
  }, [isAuth, activeTab, router])

  return (
      <main className="max-w-7xl mx-auto flex">
        {/* Desktop Sidebar */}
        <ProfileSidebar
          navItems={NAV_ITEMS}
          activeTab={activeTab}
          setActiveTab={handleTabChange}
          className="hidden md:block"
          translations={translations}
        />

        {/* Desktop Main Content */}
        <div className="hidden md:block flex-1 md:p-16 md:pt-10 bg-white">
          {getTabComponent(activeTab || 'profile')}
        </div>

        {/* Mobile View */}
        <div className="block md:hidden p-4 pt-[80px] w-full min-h-screen">
          {activeTab === null ? (
            <ProfileMobileMenu
              navItems={NAV_ITEMS}
              setActiveTab={(key: string) => setActiveTab(key)}
              translations={translations}
            />
          ) : (
            <>
              <CommonHeader style="fixed top-0 left-0 right-0 z-10 shadow-sm" title={NAV_ITEMS.find(i => i.key === activeTab)?.label || ''} showSearch={false} showCart={false} showBack={true} backPath={"/profile"} showHeart={false} />
              {getTabComponent(activeTab)}
            </>
          )}
        </div>
      </main>
  )
}
